import React, { Suspense, lazy, useContext, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useIdleTimer } from "react-idle-timer";
import { generateHashKey2, uniqueID2 } from "../utils/utilFuctions";
import Spinner from "./shared/Spinner";
import { ADMIN_SESSION_TIMER, checkSession } from "../utils/Session";
import { GlobalContext } from "../Context/GlobalState";
import AdminLogin2 from "./user-pages/AdminLogin2";
import CreateUser from "./create-user/CreateUser";
import UserKycDetails from "./user-kyc-details/UserKycDetails";
import AllUserList from "./all-user-list/AllUserList";
// import DMTHistory from "./dmt-history/DMTHistory";
import DMTHistory from "./dmt-history-3/DMTHistory";
import AccountLedger from "./account-ledger/AccountLedger";
import ViewLoad from "./view-load/ViewLoad";
//import AllUserKYC from "./all-user-kyc/AllUserKYC";
import AllUserKYC from "./all-user-kyc-2/AllUserKYC";
import CreateLoadRequest from "./create-load-request/CreateLoadRequest";
// import AEPSReport from "./aeps-report/AEPSReport";
import AEPSReport from "./aeps-report-3/AEPSReport";
// import BBPSReport from "./bbps-report/BBPSReport";
import BBPSReport from "./bbps-report-2/BBPSReport";
import Customers from "./customers/Customers";
import SmartCollect from "./virtual/smartcollect";
import DMTRefundReport from "./dmt-refund-report/DMTRefundReport";
import AEPSRefundReport from "./aeps-refund-report/AEPSRefundReport";
import BBPSRefundReport from "./bbps-refund-report/BBPSRefundReport";
import TimeReport from "./time-report/TimeReport";
import BalanceReport from "./balance-report/BalanceReport";
import CnfUseReportMaster from "./cnf-use-report-master/CnfUseReportMaster";
import CnfUseReportDist from "./cnf-use-report-dist/CnfUseReportDist";
import CnfUseReportRet from "./cnf-use-report-ret/CnfUseReportRet";
import CreateAdminUser from "./users/CreateAdminUser";
import CreateTariff from "./create-tariff/CreateTariff";
import ViewTariff from "./view-tariff/ViewTariff";
import ViewTariffPlans from "./view_tariff_plans/ViewTariffPlans";
import ModuleTest from "./admin-module-test/Test";
import MyProfile from "./my profile/MyProfile";
import ViewTicketList from "./view-ticket-list/ViewTicketList";
import ViewLoanEnquiryList from "./loan-enquiry-list/ViewLoanEnquiryList";
import LoadBankList from "./load-bank-list/LoadBankList";
import SalesReport from "./sales_report/SalesReport";
import UserAccessUpdate from "./user-access-update/UserAccessUpdate";
import userNotification from "./user-notification/userNotification";
import NotificationList from "./Notification-List/NotificationList";
import masterTariff from "./master-tariff/masterTariff";
import AdminLedgerReport from "./admin-retailer-ledger/LedgerReport";
// import SettlementReport2 from "./settlement-report/SettlementReport2";
import SettlementReport2 from "./settlement-report-2/SettlementReport2";
import UserView from "./user-view/UserView";
import AddFundsAdmin from "./add-funds/AddFunds";
import Dashboard2 from "./dashboard/Dashboard2";
import UserMapping from "./user-mapping/UserMapping";
import ForgetPasswordAdmin from "./user-pages/ForgetPasswordAdmin";
import AEPSFingpayResponseList from "./aeps-fingpay-response-list/AEPSFingpayResponseList";
import PGReport from "./pg-report/PGReport";
import TwoFactorReport from "./two-factor-report/TwoFactorReport";
import AppVersionChange from "./app-version-change/AppVersionChange";
import DocKYCInitiate from "./doc-kyc-initiate/DocKycInitiate";
import AepsOnboardingReInitiate from "./aeps-onboarding-reinitiate/AepsOnboardingReInitiate";
import ODRequestDocUpload from "./od-request-doc-upload/ODRequestDocUpload";
import AllCreditRequests from "./all-credit-requests/AllCreditRequests";
import AllODRequestDocs from "./all-od-requests-docs/AllODRequestDocs";
import PgSettlementTable from "./pg-settlement-report/PGSettlementReport";
import AllTransactionsDownload from "./dashboard/AllTransactionsDownload";
import SmartCollectPaymentsTable from "./virtual/SmartCollectPaymentsTable";
import SmsConfiguration from "./users/NotificationTest";
import CreditCardBillPaymentReport from "./credit-card-bill-payment-report/CreditCardBillPaymentReport";
import ProcessSalary from "./process_salary/ProcessSalary";
import AddSalaryDetails from "./add_salary_details/AddSalaryDetails";
import AllServicesAdmin from "./services-access/ServicesActivate";
import FundHoldReport from "./fund_hold_report/FundHoldReport";
import BulkSalaryRecordAdd from "./process_salary/BulkSalaryRecordAdd";
import AllServicesReport from "./all-services-report/AllServicesReport";
import VirtualPaymentReport from "./virtual-payment-report/VirtualPaymentReport";
import WalletToWalletReport from "./wallet-to-wallet-report/WalletToWalletReport";
import PaymentGetwayReport from "./reports/payment-gateway-report/PaymentGatewayReport";
import SuperAdminReportDownload from "./super-admin-report/SuperAdminReport";
import ReviewKycForm from "./review-kyc/ReviewKycForm";
import AllReviewKyc from "./all-review-kyc/AllReviewKyc";
import AllCreditCardKycReport from "./all-credit-card-kyc/AllCreditCardKycReport";
import AllChargeBackCases from "./all-chargback-cases/AllChargeBackCases";
import MarcomDocAdmin from "./marcom-doc/MarcomDocAdmin";
import APITopupAdmin from "./api-topup/APITopup";
import AEPSLogsReport from "./aeps-logs/AEPSLogsReport";
import OrderApi from "./json-component/JsonMapper";
import UserActivity from "./user-activity/UserActivity";
import CreditCardTransactions from "./credit-card-transactions/CreditCardTransactions";
import CreditCardDetails from "./credit-card-details/CreditCardDetails";
import BillDetails from "./bill-details/BillDetails";
import PgCommercials from "./commercials/pg-commercials/PGCommercials";
import AdminActivityLogs from "./admin-activity/AdminActivityLogs";
import LienAmount from "./lien-amount/LienAmount";
import AllUserLedger from "./reports/all-user-ledger/AllUserLedger";
import QueueManagement from "./queue-management/QueueManagement";
import AdminDmt from "./DMT/AdminDmt";
import UserReviewDetails from "./review-report/UserReviewDetails";
import VendorPaymentReport from "./vendor-payment-report/VendorPaymentReport";
import AdminRewardsScreen from "./admin-rewards/RewardsScreen";
import CmsReport from "./cms-report/CmsReport";
import SuperAdmin from "./super-admin/SuperAdmin";
import SalesFieldReportTable from "./sales-field-report/SalesFieldReportTable";
import SaledFieldReport from "./sales-field-report/SalesFieldReport";
import ServiceRequestReport from "./service-requests/ServiceRequestReport";
import QrReport from "./QR-REPORT/QrReport";
import AccountStatementUpload from "./account-statement-upload/AccountStatementUpload";
import AepsLogs2 from "./aeps-logs-2/AepsLogs2";
import OutletList from "./aeps-2/Outlet";
import LoadRequests from "./load-requests/LoadRequest";
import ReconDashboard from "./recon-dashboard/DashboardData";
import MATMReport from "./MATM-Report/MATMReport";
import UserAttempts from "./user-attempts/UserAttempts";
import ChargesCommissionCredit from "./support/ChargesandCommissionCradit ";
import OnboardingForm from "./support/AepsOnboarding";
import updatekycstatus from "./support/UpdateKycStatus";
import LoadRequestStatus from "./support/LoadRequestStatus";
import StatusChange from "./support/StatusChange";
import EkycLogs from "./support/EkycLogs";
import UserNotification from "./support/UserNotification/UserNotification2";
import UserNotification2 from "./support/UserNotification/UserNotification2";
import MatmMain from "./support/MAtm/MatmMain";
import useSecurity from "../utils/useSecurity";
import { getLatLong, getMyIPAddress, getClientIP } from "../utils/utilFuctions";
import { BASE_URL_API } from "../utils/Constants";
import { API_ENDPOINTS } from "../utils/apiEndpoints";
import AepsCw from "./support/MAtm/AepsCw";
import MainRecon from "./support/MAtm2.js/MainRecon";
import ServiceAccessUpdate from "./support/ServicesAccess/ServicesAccessUpdate";
import PushNotification from "./Notification-List/PushNotification";
import AllAdminListUser from "./support/SuperAdminAccess/AllAdminListUser";
import AllAdminServices from "./support/SuperAdminAccess/AllAdminServices";
import { adminAuth } from "../config";
import LocationGuard from "../LocationGuard";
const Error404 = lazy(() => import("./error-pages/Error404"));

const isRouteAllowed = (pathname) => {
  const subMenus = JSON.parse(sessionStorage.getItem("sub_menus")) || [];

  // Always allow dashboard
  if (pathname === "/admin/dashboard") return true;

  return subMenus.some(
    (m) => m.menu_url === pathname
  );
};


const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { user } = useContext(GlobalContext);
  const storedUser = JSON.parse(sessionStorage.getItem("user_details"));
  const isAuthenticated = (user && user.pkid) || (storedUser && storedUser.pkid);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          isRouteAllowed(props.location.pathname) ? (
            <Component {...props} />
          ) : (
            <Redirect to="/admin/dashboard" />
          )
        ) : (

          <Redirect to="/admin" />
        )
      }
    />
  );
};


const AppRoutes = () => {
  useSecurity();
  const { username1, password1 } = adminAuth;
  const { removeUserInfo, user } = useContext(GlobalContext);



  const onPrompt = () => {
    // Fire a Modal Prompt
    console.log("onPrompt");
  };

  const onIdle = () => {
    if (user && user.pkid !== "9") {
      removeUserInfo();
      checkSession();
    }
  };

  const onActive = (event) => { };

  const onAction = (event) => { };

  const {
    start,
    reset,
    activate,
    pause,
    resume,
    isIdle,
    isPrompted,
    isLeader,
    getTabId,
    getRemainingTime,
    getElapsedTime,
    getLastIdleTime,
    getLastActiveTime,
    getTotalIdleTime,
    getTotalActiveTime,
  } = useIdleTimer({
    onPrompt,
    onIdle,
    onActive,
    onAction,
    timeout: ADMIN_SESSION_TIMER,
    promptTimeout: 0,
    events: [
      "mousemove",
      "keydown",
      "wheel",
      "DOMMouseScroll",
      "mousewheel",
      "mousedown",
      "touchstart",
      "touchmove",
      "MSPointerDown",
      "MSPointerMove",
      "visibilitychange",
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    name: "idle-timer",
    syncTimers: 0,
    leaderElection: false,
  });

  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      // Disable right-click
      // document.addEventListener("contextmenu", (e) => e.preventDefault());

      function ctrlShiftKey(e, keyCode) {
        return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
      }

      document.onkeydown = (e) => {
        // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
        if (
          e.keyCode === 123 ||
          ctrlShiftKey(e, "I") ||
          ctrlShiftKey(e, "J") ||
          ctrlShiftKey(e, "C") ||
          (e.ctrlKey && e.keyCode === "U".charCodeAt(0))
        )
          return false;
      };
    }
  }, []);

  const getRoleDetails = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
      );
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.pkid,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.GET_ROLE_DATA}`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        sessionStorage.setItem("menus", JSON.stringify(data.menus));
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const fetchSubMenus = async (menuId) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
      );
      myHeaders.append("Content-Type", "application/json");
      let coords = await getLatLong()
      const ip = await getClientIP();

      var raw = JSON.stringify({
        userid: user.pkid,
        menu: menuId,
        lattitude: coords[0],
        longitude: coords[1],
        ip: ip,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.GET_SUBMENU}`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        sessionStorage.setItem("sub_menus", JSON.stringify(data.sub_menus));
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    const hasMenus = sessionStorage.getItem("sub_menus");
    if (user && user.pkid && !hasMenus) {
      fetchSubMenus();
      getRoleDetails();
    }
  }, [user]);

  return (
    <Suspense fallback={<Spinner />}>
      <LocationGuard>
      <Switch>
        {/* Dashboard */}
        <ProtectedRoute exact path="/admin/dashboard" component={Dashboard2} />

        {/* Tariff */}
        <ProtectedRoute exact path="/admin/view_tariff" component={ViewTariff} />
        <ProtectedRoute exact path="/admin/create_tariff" component={CreateTariff} />
        <ProtectedRoute
          exact
          path="/admin/view_tariff_plans"
          component={ViewTariffPlans}
        />

        {/* BANK */}
        <ProtectedRoute exact path="/admin/load-bank-list" component={LoadBankList} />

        {/* account */}
        <ProtectedRoute exact path="/admin/account_ledger" component={AccountLedger} />
        <ProtectedRoute exact path="/admin/add-funds" component={AddFundsAdmin} />
        <ProtectedRoute exact path="/admin/view_load" component={ViewLoad} />
        <ProtectedRoute
          exact
          path="/admin/create_load_request"
          component={CreateLoadRequest}
        />
        <ProtectedRoute
          exact
          path="/admin/credit_requests"
          component={AllCreditRequests}
        />
        <ProtectedRoute
          exact
          path="/admin/od_requests_docs"
          component={AllODRequestDocs}
        />
        <ProtectedRoute
          exact
          path="/admin/od_request_doc_submit"
          component={ODRequestDocUpload}
        />

        <ProtectedRoute exact path="/admin/api-topup" component={APITopupAdmin} />
        <ProtectedRoute exact path="/admin/super_admin" component={SuperAdmin} />
        <ProtectedRoute
          exact
          path="/admin/bank_statement_upload"
          component={AccountStatementUpload}
        />
        <ProtectedRoute exact path="/admin/recon_dashboard" component={ReconDashboard} />

        {/* User */}

        <ProtectedRoute exact path="/admin/all_user_list" component={AllUserList} />
        <ProtectedRoute exact path="/admin/user-view" component={UserView} />
        <ProtectedRoute exact path="/admin/create-user" component={CreateUser} />
        <ProtectedRoute exact path="/admin/user_mapping" component={UserMapping} />
        <ProtectedRoute
          exact
          path="/admin/service_requests"
          component={ServiceRequestReport}
        />
        <ProtectedRoute
          exact
          path="/admin/admin_activity"
          component={AdminActivityLogs}
        />
        <ProtectedRoute exact path="/admin/lien_amount" component={LienAmount} />
        <ProtectedRoute
          exact
          path="/admin/queue-management"
          component={QueueManagement}
        />
        <ProtectedRoute exact path="/admin/dmt" component={AdminDmt} />
        <ProtectedRoute exact path="/admin/login_attempts" component={UserAttempts} />

        {/* kyc */}
        <ProtectedRoute exact path="/admin/all_user_kyc" component={AllUserKYC} />
        <ProtectedRoute exact path="/admin/all_kyc_review" component={AllReviewKyc} />
        <ProtectedRoute
          exact
          path="/admin/all_credit_card_kyc"
          component={AllCreditCardKycReport}
        />
        <ProtectedRoute
          exact
          path="/admin/all_chargeback_cases"
          component={AllChargeBackCases}
        />
        <ProtectedRoute
          exact
          path="/admin/service_requests"
          component={ServiceRequestReport}
        />

        {/* Report */}
        <ProtectedRoute exact path="/admin/dmt_history" component={DMTHistory} />
        <ProtectedRoute exact path="/admin/aeps_report" component={AEPSReport} />
        <ProtectedRoute exact path="/admin/bbps_report" component={BBPSReport} />
        <ProtectedRoute
          exact
          path="/admin/settlement_report"
          component={SettlementReport2}
        />
        <ProtectedRoute exact path="/admin/pg_report" component={PGReport} />
        <ProtectedRoute exact path="/admin/view_load" component={ViewLoad} />
        <ProtectedRoute
          exact
          path="/admin/sales_dsr_report"
          component={SaledFieldReport}
        />
        <ProtectedRoute
          exact
          path="/admin/pg_settlement_report"
          component={PgSettlementTable}
        />
        <ProtectedRoute
          exact
          path="/admin/common_report_download"
          component={AllTransactionsDownload}
        />
        <ProtectedRoute
          exact
          path="/admin/credit_card_bill_payment_report"
          component={CreditCardBillPaymentReport}
        />
        <ProtectedRoute
          exact
          path="/admin/fund_hold_report"
          component={FundHoldReport}
        />
        <ProtectedRoute
          exact
          path="/admin/all_services_report"
          component={AllServicesReport}
        />
        <ProtectedRoute
          exact
          path="/admin/wallet_to_wallet_report"
          component={WalletToWalletReport}
        />
        <ProtectedRoute
          exact
          path="/admin/payment-gateway-recon-report"
          component={PaymentGetwayReport}
        />
        <ProtectedRoute exact path="/admin/all_user_ledger" component={AllUserLedger} />
        <ProtectedRoute
          exact
          path="/admin/vendor_payments"
          component={VendorPaymentReport}
        />
        <ProtectedRoute exact path="/admin/cms_report" component={CmsReport} />
        <ProtectedRoute exact path="/admin/qr_report" component={QrReport} />
        <ProtectedRoute exact path="/admin/matm_report" component={MATMReport} />
        <ProtectedRoute exact path="/admin/sales_report" component={SalesReport} />

        {/* Notification */}
        <ProtectedRoute
          exact
          path="/admin/userNotification"
          component={userNotification}
        />
        <ProtectedRoute
          exact
          path="/admin/NotificationList"
          component={NotificationList}
        />
        <ProtectedRoute
          exact
          path="/admin/PushNotification"
          component={PushNotification}
        />

        {/* support */}
        <ProtectedRoute
          exact
          path="/admin/view_ticket_list"
          component={ViewTicketList}
        />
        <ProtectedRoute exact path="/admin/all_services" component={AllServicesAdmin} />
        <ProtectedRoute exact path="/admin/aeps_logs" component={AEPSLogsReport} />
        <ProtectedRoute exact path="/admin/aeps2_logs" component={AepsLogs2} />
        <ProtectedRoute exact path="/admin/aeps2_outlets" component={OutletList} />
        <ProtectedRoute
          exact
          path="/admin/Charges&CommissionCredit"
          component={ChargesCommissionCredit}
        />
        <ProtectedRoute exact path="/admin/AepsOnboarding" component={OnboardingForm} />
        <ProtectedRoute
          exact
          path="/admin/UpdateKycStatus"
          component={updatekycstatus}
        />
        <ProtectedRoute exact path="/admin/EkycLogs" component={EkycLogs} />
        <ProtectedRoute exact path="/admin/MAtm_TXN" component={MatmMain} />
        <ProtectedRoute exact path="/admin/TxnStatusChange" component={StatusChange} />
        <ProtectedRoute exact path="/admin/AepsCw" component={AepsCw} />
        {/* <Route exact path="/admin/MatmMainRecon" component={MainRecon} /> */}
        <ProtectedRoute exact path="/admin/MatmRecon" component={MainRecon} />
        <Route exact path="/admin/ServicesAccessUpdate" component={ServiceAccessUpdate} />
        <ProtectedRoute exact path="/admin/new_all_admin_list_users" component={AllAdminListUser} />
        <Route exact path="/admin/new_allservices/:id" component={AllAdminServices} />

        {/* Tech Support */}
        <ProtectedRoute
          exact
          path="/admin/two_factor_report"
          component={TwoFactorReport}
        />
        <ProtectedRoute
          exact
          path="/admin/app_version_change"
          component={AppVersionChange}
        />
        <ProtectedRoute
          exact
          path="/admin/aeps_onboarding_reinitiate"
          component={AepsOnboardingReInitiate}
        />
        <ProtectedRoute
          exact
          path="/admin/doc_kyc_initiate"
          component={DocKYCInitiate}
        />
        {/* ------------ */}

        {/* Profile */}
        <ProtectedRoute exact path="/admin/my_profile" component={MyProfile} />
        {/* -------- */}

        <ProtectedRoute
          exact
          path="/admin/user-kyc-details"
          component={UserKycDetails}
        />
        <ProtectedRoute exact path="/admin/marcom-doc-view" component={MarcomDocAdmin} />



        <Route exact path="/admin/load_requests" component={LoadRequests} />
        <Route
          exact
          path="/admin/user-rewards"
          component={AdminRewardsScreen}
        />
        <Route
          exact
          path="/admin/credit_card_transactions"
          component={CreditCardTransactions}
        />
        <Route
          exact
          path="/admin/credit_card_details"
          component={CreditCardDetails}
        />
        <Route
          exact
          path="/admin/get_all_bill_details"
          component={BillDetails}
        />
        <Route
          exact
          path="/admin/add_salary_details"
          component={AddSalaryDetails}
        />
        {/* not in use  */}
        {/* <Route exact path="/admin/review_kyc" component={ReviewKycForm} />
        <Route exact path="/admin/masterTariff" component={masterTariff} />
        <Route exact path="/admin/customers" component={Customers} />
        <Route exact path="/admin/virtual" component={SmartCollect} />
        <Route exact path="/admin/time_report" component={TimeReport} />
        <Route exact path="/admin/balance_report" component={BalanceReport} />
        <Route exact path="/admin/load_requests" component={LoadRequests} /> */}
        {/* <Route
          exact
          path="/admin/bank_statement_upload"
          component={AccountStatementUpload}
        />
        <Route exact path="/admin/agent_ledger" component={AdminLedgerReport} />
        <Route
          exact
          path="/admin/user-rewards"
          component={AdminRewardsScreen}
        />
        <Route exact path="/admin/process_salary" component={ProcessSalary} />
        <Route
          exact
          path="/admin/bulk_salary_add"
          component={BulkSalaryRecordAdd}
        /> */}
        {/* <Route
          exact
          path="/admin/add_salary_details"
          component={AddSalaryDetails}
        />

        <Route
          exact
          path="/admin/aeps_fingpay_reponse"
          component={AEPSFingpayResponseList}
        />

        <Route
          exact
          path="/admin/virtual_report"
          component={VirtualPaymentReport}
        /> */}

        {/* <Route
          exact
          path="/admin/admin_report_download"
          component={SuperAdminReportDownload}
        />
        <Route exact path="/admin/user_activity" component={UserActivity} />
        <Route
          exact
          path="/admin/credit_card_transactions"
          component={CreditCardTransactions}
        />
        <Route
          exact
          path="/admin/credit_card_details"
          component={CreditCardDetails}
        /> */}
        {/* <Route
          exact
          path="/admin/get_all_bill_details"
          component={BillDetails}
        />
        <Route
          exact
          path="/admin/commercials/pg_commercials"
          component={PgCommercials}
        />
        <Route
          exact
          path="/admin/user-review-details"
          component={UserReviewDetails}
        />

        <Route exact path="/admin/json_mapper" component={OrderApi} />

        <Route exact path="/admin/sms" component={SmsConfiguration} /> */}

        {/* REFUND REPORT */}
        {/* <Route
          exact
          path="/admin/dmt_refund_report"
          component={DMTRefundReport}
        />
        <Route
          exact
          path="/admin/aeps_refund_report"
          component={AEPSRefundReport}
        />
        <Route
          exact
          path="/admin/bbps_refund_report"
          component={BBPSRefundReport}
        /> */}

        {/* CNF USE REPORT */}
        {/* <Route
          exact
          path="/admin/cnf_use_report_master"
          component={CnfUseReportMaster}
        />
        <Route
          exact
          path="/admin/cnf_use_report_dist"
          component={CnfUseReportDist}
        />
        <Route
          exact
          path="/admin/cnf_use_report_ret"
          component={CnfUseReportRet}
        />

        <Route
          exact
          path="/admin/create_admin_user"
          component={CreateAdminUser}
        />

        <Route
          exact
          path="/admin/view_loan_enquiry_list"
          component={ViewLoanEnquiryList}
        /> */}

        {/* User Access Update */}
        <Route
          exact
          path="/admin/user_access_manage"
          component={UserAccessUpdate}
        />

        {/* <Route exact path="/admin/LoadRequestReject" component={LoadRequestStatus} /> */}
        {/* <Route
          exact
          path="/admin/User_Notification"
          component={UserNotification2}
        /> */}

        {/* <Route exact path="/admin/test" component={ModuleTest} /> */}

        {/* Tariff */}

        <Route exact path="/admin" component={AdminLogin2} />
        <Route
          exact
          path="/admin/forget-password"
          component={ForgetPasswordAdmin}
        />
        <Route path="/error-pages/error-404" component={Error404} />
        {/* <Route path="*">
          <Redirect to="/admin/dashboard" />
        </Route> */}
        <Route path="*">

          {user && user.pkid ? <Redirect to="/admin/dashboard" /> : <Redirect to="/admin" />}
        </Route>
        <Redirect to="/admin" />
      </Switch>
      </LocationGuard>
    </Suspense>
  );
};

export default AppRoutes;
